import { createContext, useContext, useState } from "react";

const Context = createContext();

export const ContextProvider = ({ children }) => {
  const [stripePromise, setStripePromise] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const [storeID, setStoreID] = useState(null);
  const [amount, setAmount] = useState(0);

  return (
    <Context.Provider
      value={{
        stripePromise,
        setStripePromise,
        clientSecret,
        setClientSecret,
        storeID,
        setStoreID,
        amount,
        setAmount,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export const Balance = () => {
  return useContext(Context);
};
